import Header from 'containers/Header'
import useDocumentTitle from 'hooks/useDocumentTitle'

function DocumentTitle({ title }) {
  useDocumentTitle(` ${title} | Ajarlee`)
  return null
}

export default function Layout({
  background,
  toolbar,
  children,
  showLogo = true,
  title,
  headerRight,
  breadcrumbs,
  headerBorder = true,
  showHeaderTitle = true,
  hideHeader = false,
}) {
  const height = hideHeader ? '0px' : '54px'

  return (
    <div className="min-h-full">
      {hideHeader && title ? <DocumentTitle title={title} /> : null}
      <main className="flex-1">
        {!hideHeader && (
          <Header showLogo={showLogo} toolbar={toolbar} pages={breadcrumbs} headerRight={headerRight} title={title} border={headerBorder} showTitle={showHeaderTitle} />
        )}
        <div
          id="rootScrollable"
          style={{
            maxHeight: `calc(100vh - ${height})`,
            minHeight: `calc(100vh - ${height})`,
            background: background || 'white',
          }}
          className="overflow-y-auto"
        >
          {children}
        </div>
      </main>
    </div>
  )
}
